import React,{Fragment} from "react";
import Header from "../../Components/Header/Header";
import Body from "../../Components/Body/Body";
import Footer from "../../Components/Footer/Footer";

const Home =(props)=>{
    // useEffect(()=>{
    //     document.title = "Google Homepage";
    // },[]);
    return(
        <Fragment>
            <section>
                <Header />
                <Body />
                <Footer />
            </section>
        </Fragment>
    )
}

export default Home;